import React from 'react';
import classnames from 'classnames';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  arrayOf, bool, objectOf, shape, string
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';
import './desktop-content.scss';

export const DesktopContent = (props) => {
  const {
    channel,
    description,
    documents,
    richContent,
    hideRichContents,
    preview,
    bullets,
    shouldShowMore,
    showRichContentsOnly
  } = props;

  const desktopContentClasses = classnames({
    'desktop-content-wrapper--show-less': shouldShowMore
  });

  const etchContent = richContent?.content;
  const displayInfoAndGuides = !!(documents.length && !showRichContentsOnly);

  return (
    <div className="desktop-content-wrapper">
      <Row className={desktopContentClasses}>
        {etchContent && !hideRichContents
          && <EtchWidgets content={etchContent} /> }
        <Col fallback={displayInfoAndGuides ? '7' : '12'} nopadding>
          <Row className="desktop-content-wrapper__main-description">
            {!showRichContentsOnly ? description : null}
            {bullets && bullets.length
              && <BulletList bullets={bullets} margin isMobile={false} />}
          </Row>
        </Col>
        {displayInfoAndGuides && (
          <Col fallback="5">
            <InfoGuides documents={documents} channel={channel} />
          </Col>
        )}
      </Row>
    </div>
  );
};

DesktopContent.displayName = 'DesktopContent';

DesktopContent.propTypes = {
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  hideRichContents: bool,
  preview: bool,
  richContent: shape({
    content: string,
    displayMode: string,
    url: string
  }),
  bullets: arrayOf(shape({})),
  shouldShowMore: bool,
  showRichContentsOnly: bool
};

DesktopContent.defaultProps = {
  hideRichContents: false,
  preview: false,
  richContent: {},
  shouldShowMore: false,
  showRichContentsOnly: false,
  bullets: []
};
